<template>
    <div class="row">
        <div class="col-12 col-lg-8 mt-5" :class="{'mx-auto' :stepFour }">
            <div class="position-relative">
                <div class="strikes-wrapper d-flex flex-row align-items-start justify-content-between">
                    <hr class="flex-fill" :class="{ active: stepTwo}"/>
                    <hr class="flex-fill" :class="{ active: stepThree}"/>
                    <hr class="flex-fill" :class="{ active: stepFour}"/>
                </div>
                <div class="steps-wrapper d-flex flex-row align-items-start justify-content-between">
                    <div>
                        <div class="circle" :class="{ active: stepOne}">
                            <img src="../../assets/images/setup/step_home.svg" alt="home">
                        </div>
                        <p class="d-none d-md-block text-left" :class="{ active: stepOne}">Your Home</p>

                    </div>
                    <div>
                        <div class="circle" :class="{ active: stepTwo}">
                            <img src="../../assets/images/setup/step_current.svg" alt="current">
                        </div>

                        <p class="d-none d-md-block text-center" :class="{ active: stepTwo}">Current Supply</p>
                    </div>
                    <div>
                        <div class="circle" :class="{ active: stepThree}">
                            <img src="../../assets/images/setup/step_energy.svg" alt="energy">
                        </div>

                        <p class="d-none d-md-block text-center" :class="{ active: stepThree}">Energy Usage</p>
                    </div>
                    <div>
                        <div class="circle" :class="{ active: stepFour}">
                            <img src="../../assets/images/setup/step_done.svg" alt="done">
                        </div>

                        <p class="d-none d-md-block text-center" :class="{ active: stepFour}">Your savings!</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4 mt-5" v-if="$route.params.backTo">
            <router-link :to="{name: $route.params.backTo, params: {details: true}}" class="btn btn-outline-info float-right"><i class="fa fa-close"></i> Close</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Steps",
        computed: {
            stepOne: function () {
                return this.stepTwo || this.$route.name === 'SetupHome';
            },
            stepTwo: function () {
                return this.stepThree || this.$route.name === 'SetupCurrent';
            },
            stepThree: function () {
                return this.stepFour || this.$route.name === 'SetupEnergy';
            },
            stepFour: function () {
                return this.$route.name === 'SetupDeal';
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/base";

    .steps-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;

        .circle {
            background-color: #F9FBFC;
            border: 1px solid #9DAFBD;
            width: 42px;
            height: 42px;
            border-radius: 42px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto 1rem;

            box-shadow: 0 2px 5px rgba(157, 175, 189, 0.5);

            &.active {
                background-color: $primary;
                border-color: $info;

                img {
                    filter: brightness(0) invert(1);
                }
            }

            + p {
                color: #9DAFBD;
                margin: 0;

                &.active {
                    font-weight: bold;
                    color: $primary;
                }
            }
        }
    }

    .strikes-wrapper {
        height: 82px;
        padding-left: 20px;
        padding-right: 30px;
        hr {
            margin: 21px 0;
            border-top: 1px solid #9DAFBD;

            &.active {
                border-color: $primary;
            }
        }
    }
</style>
